/* ============================================================================
   KADI — Theme UI
   Header scroll/hide · full-screen menu · cart drawer + AJAX cart ·
   accordions · qty steppers · product form (add to cart) · variants · quick-view.
   Plain ES, no framework. Progressive enhancement: everything has a no-JS path.
   ========================================================================== */
(function () {
  'use strict';
  window.KADI = window.KADI || {};
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  KADI.money = money;

  ready(function () {
    /* Scroll lock helpers (ex-smooth-scroll.js/Lenis — scroll natif désormais).
       Utilisés par le menu, le cart drawer et le quick-view. */
    KADI.stopScroll  = KADI.stopScroll  || function () { document.body.style.overflow = 'hidden'; };
    KADI.startScroll = KADI.startScroll || function () { document.body.style.overflow = ''; };

    /* ---------------------------------------------------------------- HEADER */
    /* Nav scroll façon Dior — trois états exclusifs :
         is-top      : haut de page, transparent par-dessus le hero
         is-pinned   : visible, opaque (--bg / --fg)
         is-unpinned : caché (translateY(-100%))
       is-top n'est posé que s'il y a un hero (la home). Ailleurs la barre est
       toujours opaque. On ne masque jamais la barre si un overlay est ouvert. */
    var header = $('[data-header]');
    if (header) {
      var hero = $('.k2-hero');   // n'existe que sur la home (pilote la couleur du texte)
      var ticking = false, lastY = window.scrollY;
      var DELTA = 6;              // seuil anti-jitter (momentum / rebond)
      var revealOffset = 0;

      function measure() { revealOffset = hero ? hero.offsetHeight : header.offsetHeight; }

      // Menu, panier ou quick-view ouvert → la barre reste où elle est.
      function overlayOpen() {
        return !!document.querySelector('[data-menu].is-open, [data-cart-drawer].is-open, [data-quickview-modal].is-open');
      }

      function setState(top, unpinned) {
        header.classList.toggle('is-top', top);
        header.classList.toggle('is-unpinned', unpinned);
        header.classList.toggle('is-pinned', !unpinned);
      }

      function onScroll(y) {
        header.classList.toggle('is-scrolled', y > 40);   // pilote le shrink (hauteur + logo)

        // Tout en haut : is-top sur TOUTES les pages. Seul le fond s'efface en fondu ;
        // la nav, le wordmark et le panier restent en ink (blanc sur le hero de la home).
        if (y <= 8) { setState(true, false); lastY = y; return; }

        // Dès qu'on quitte le haut, la barre est opaque — même si aucune bascule
        // pinned/unpinned n'a lieu ensuite (descente sous le seuil DELTA).
        header.classList.remove('is-top');

        if (overlayOpen()) { lastY = y; return; }

        if (y < lastY) {
          // Le MOINDRE mouvement vers le haut révèle la barre, sans seuil : c'est
          // le geste par lequel l'utilisateur réclame la navigation.
          setState(false, false);
        } else if (y > lastY + DELTA && y > revealOffset) {
          // Masquer exige un franc mouvement vers le bas. Le seuil absorbe le
          // jitter (momentum, rebond) qui faisait clignoter la barre.
          setState(false, true);
        } else {
          // Micro-descente : on n'agit pas ET lastY n'avance pas → le delta s'accumule.
          return;
        }

        lastY = y;
      }

      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { onScroll(window.scrollY); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', measure, { passive: true });

      measure();
      onScroll(window.scrollY);
    }

    /* ----------------------------------------------------------- OVERLAY UTIL */
    var overlay = $('[data-overlay]');
    function showOverlay() { if (overlay) { overlay.hidden = false; requestAnimationFrame(function(){ overlay.classList.add('is-on'); }); } }
    function hideOverlay() { if (overlay) { overlay.classList.remove('is-on'); setTimeout(function(){ overlay.hidden = true; }, 250); } }

    /* -------------------------------------------------------------- MENU */
    var menu = $('[data-menu]');
    var menuOpen = false, menuTrigger = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
    function trapFocus(e) {
      if (e.key !== 'Tab' || !menuOpen) return;
      var f = $$(FOCUSABLE, menu).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function openMenu() {
      if (!menu) return; menu.hidden = false;
      menuTrigger = document.activeElement;
      requestAnimationFrame(function(){ menu.classList.add('is-open'); });
      menuOpen = true; document.documentElement.style.overflow = 'hidden';
      if (KADI.stopScroll) KADI.stopScroll();
      $$('[data-menu-toggle][aria-expanded]').forEach(function(b){ b.setAttribute('aria-expanded','true'); });
      document.addEventListener('keydown', trapFocus);
      var first = menu.querySelector(FOCUSABLE); if (first) first.focus();
    }
    function closeMenu() {
      if (!menu) return; menu.classList.remove('is-open');
      menuOpen = false; document.documentElement.style.overflow = '';
      if (KADI.startScroll) KADI.startScroll();
      $$('[data-menu-toggle][aria-expanded]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      document.removeEventListener('keydown', trapFocus);
      if (menuTrigger && menuTrigger.focus) menuTrigger.focus();
      setTimeout(function(){ if (!menuOpen) menu.hidden = true; }, 650);
    }
    $$('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); menuOpen ? closeMenu() : openMenu(); });
    });
    if (menu) {
      // Close when a nav link is followed, or when clicking empty overlay space.
      menu.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (link && !link.hasAttribute('data-cart-toggle')) { closeMenu(); return; }
        // Clic sur le voile (hors du panneau) → fermeture. Le panneau ne ferme pas.
        if (e.target === menu) closeMenu();
      });
    }

    /* ------------------------------------------------------------ CART DRAWER */
    var drawer = $('[data-cart-drawer]');
    var drawerOpen = false;
    function openDrawer() {
      if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
      drawerOpen = true; showOverlay(); if (KADI.stopScroll) KADI.stopScroll();
      document.documentElement.style.overflow = 'hidden';
      var c = drawer.querySelector('.cart-drawer__close'); if (c) c.focus();
    }
    function closeDrawer() {
      if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
      drawerOpen = false; if (!menuOpen) hideOverlay();
      if (KADI.startScroll) KADI.startScroll(); document.documentElement.style.overflow = '';
    }
    $$('[data-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        // Header/menu cart link points to /cart as no-JS fallback; intercept to open drawer.
        if (el.tagName === 'A') e.preventDefault();
        if (menuOpen) closeMenu(); // drawer sits below the menu — close menu first
        drawerOpen ? closeDrawer() : openDrawer();
      });
    });

    if (overlay) overlay.addEventListener('click', function () { if (drawerOpen) closeDrawer(); if (menuOpen) closeMenu(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (drawerOpen) closeDrawer(); if (menuOpen) closeMenu(); }
    });

    /* ------------------------------------------------------- CART AJAX SYNC */
    function setCartCount(n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n; el.hidden = (n === 0 && el.classList.contains('header__cart-count'));
      });
    }
    function renderItems(cart) {
      var body = $('[data-cart-items]'); if (!body) return;
      var foot = $('[data-cart-foot]');
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty"><p class="cart-drawer__title">Your cart is empty.</p>' +
          '<p class="cart-drawer__note">Performance meets lifestyle — start with the drop.</p></div>';
        if (foot) foot.hidden = true;
        bindToggles(body);
      } else {
        var html = cart.items.map(function (item, i) {
          var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x$1$2') + '" width="64" height="64" alt="" loading="lazy">' : '';
          var variant = (item.options_with_values && item.product_has_only_default_variant === false) ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
          return '<div class="cart-line" data-line-key="' + item.key + '" data-line-index="' + (i + 1) + '">' +
            '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
            '<div class="cart-line__info"><a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' + variant +
              '<div class="cart-line__qty" data-qty><button data-qty-down aria-label="Decrease">&minus;</button>' +
              '<span data-qty-value>' + item.quantity + '</span>' +
              '<button data-qty-up aria-label="Increase">+</button></div>' +
              '<button class="cart-line__remove" data-line-remove>Remove</button></div>' +
            '<div class="cart-line__price">' + money(item.final_line_price) + '</div></div>';
        }).join('');
        body.innerHTML = html;
        if (foot) foot.hidden = false;
      }
      var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
      setCartCount(cart.item_count);
    }
    function refreshCart(open) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderItems(cart); if (open) openDrawer(); return cart; });
    }
    KADI.refreshCart = refreshCart;

    function changeLine(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { renderItems(cart); return cart; });
    }

    // Delegated qty / remove inside drawer
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var line = e.target.closest('[data-line-key]'); if (!line) return;
        var key = line.getAttribute('data-line-key');
        var val = parseInt(line.querySelector('[data-qty-value]') ? line.querySelector('[data-qty-value]').textContent : '1', 10);
        if (e.target.closest('[data-qty-up]'))   changeLine(key, val + 1);
        else if (e.target.closest('[data-qty-down]')) changeLine(key, Math.max(0, val - 1));
        else if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
      });
    }

    /* --------------------------------------------------- ADD TO CART (forms) */
    function bindProductForms(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.__kadiBound) return; form.__kadiBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw res.d;
            return refreshCart(true);
          })
          .catch(function (err) {
            var msg = form.querySelector('[data-form-error]');
            if (msg) msg.textContent = (err && err.description) || 'Could not add to cart.';
          })
          .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
      });
    });
    }

    function bindToggles(scope) {
      $$('[data-cart-toggle]', scope).forEach(function (el) {
        el.addEventListener('click', function (e) { if (el.tagName === 'A') e.preventDefault(); drawerOpen ? closeDrawer() : openDrawer(); });
      });
    }

    /* ----------------------------------------------------------- ACCORDIONS */
    $$('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion]');
        var panel = item && item.querySelector('[data-accordion-panel]');
        var open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });

    /* ------------------------------------- PASTILLES DE COULEUR (CARTES PRODUIT) */
    /* Un clic sur une pastille prévisualise la couleur (packshot + image de survol)
       et présélectionne la variante : tous les liens de la carte pointent alors vers
       /products/x?variant=ID, de sorte que la fiche s'ouvre sur le bon coloris. */
    $$('.pcard__colorways').forEach(function (group) {
      var card = group.closest('.pcard');
      if (!card) return;
      var dots = $$('[data-cw]', group);
      if (dots.length < 2) return;
      var img1 = card.querySelector('.pcard__img--1');
      var img2 = card.querySelector('.pcard__img--2');
      var links = $$('a[href]', card);

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          if (img1 && dot.dataset.img) {
            // srcset/sizes gagneraient sur src : on les retire avant de repeindre.
            img1.removeAttribute('srcset');
            img1.removeAttribute('sizes');
            img1.src = dot.dataset.img;
          }
          if (img2 && dot.dataset.img2) img2.src = dot.dataset.img2;
          dots.forEach(function (d) { d.setAttribute('aria-checked', d === dot ? 'true' : 'false'); });
          if (dot.dataset.url) links.forEach(function (a) { a.setAttribute('href', dot.dataset.url); });
        });
      });
    });

    /* -------------------------------------------- GALERIE PDP : CARROUSEL MOBILE */
    /* La piste est un empilement en desktop et un carrousel scroll-snap en mobile
       (CSS seule). Ici on ne fait que refléter le scroll dans la fine barre de
       progression — même logique que .k2-scrollbar sur la home. */
    $$('[data-gallery-group]').forEach(function (group) {
      var track = group.querySelector('[data-gallery-track]');
      var bar   = group.querySelector('[data-gallery-bar]');
      var thumb = group.querySelector('[data-gallery-bar-thumb]');
      if (!track || !bar || !thumb) return;

      var ticking = false;
      function sync() {
        var vis = track.clientWidth, total = track.scrollWidth;
        if (!vis || total <= vis) return;               // desktop : rien à indiquer
        var ratio = vis / total;
        var max = total - vis;
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.left = ((track.scrollLeft / max) * (1 - ratio) * 100) + '%';
      }
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });

    /* ------------------------------------------------------- TABS (PDP V2) */
    /* Onglets horizontaux Description | Size and fit | Details : actif souligné,
       un seul panneau visible, contenu affiché en entier. */
    $$('[data-tabs]').forEach(function (tabs) {
      var btns = $$('[role="tab"]', tabs);
      var panels = $$('[role="tabpanel"]', tabs);
      if (!btns.length || !panels.length) return;

      function select(i) {
        btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
      }

      btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
      select(0);
    });

    /* -------------------------------------------------------- QTY (PDP etc.) */
    $$('[data-qty]:not([data-cart-drawer] [data-qty])').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.addEventListener('click', function (e) {
        if (!input) return;
        if (e.target.closest('[data-qty-up]'))   input.value = (parseInt(input.value, 10) || 1) + 1;
        if (e.target.closest('[data-qty-down]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ------------------------------------------------------------- VARIANTS */
    // Colorway / option selection on PDP. Expects variant data JSON in [data-variants].
    function bindVariants(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.__kadiVarBound) return; form.__kadiVarBound = true;
      var dataEl = form.querySelector('[data-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[name="id"]');
      var priceEl = $('[data-product-price]', form.closest('[data-product]') || document);
      var addBtn  = form.querySelector('[data-add-btn]');

      function currentOptions() {
        return $$('[data-option-index]', form).map(function (group) {
          var checked = group.querySelector(':checked') || group.querySelector('[aria-checked="true"]');
          return checked ? checked.value : null;
        });
      }
      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn) {
          var avail = match.available;
          addBtn.disabled = !avail;
          // PDP V2 : le prix vit DANS le bouton ([data-add-label] + [data-product-price]) —
          // on ne remplace que le libellé, jamais tout le contenu du bouton.
          var addLbl = addBtn.querySelector('[data-add-label]');
          var lblText = avail ? (addBtn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
          if (addLbl) addLbl.textContent = lblText;
          else addBtn.textContent = lblText;
          addBtn.classList.toggle('is-soldout', !avail);
        }
        // PDP V2 : une pile d'images par couleur — on n'affiche que celle de la variante.
        var groups = $$('[data-gallery-group]');
        if (groups.length) {
          groups.forEach(function (g) { g.hidden = g.getAttribute('data-variant-id') !== String(match.id); });
          var sub = $('[data-variant-subtitle]');
          if (sub && match.title) sub.textContent = match.title;
        } else if (match.featured_media_id) {
          // Ancienne galerie à vignettes (quick-view).
          var thumb = $('[data-gallery-thumbs] [data-media-id="' + match.featured_media_id + '"]');
          if (thumb) setStageImage(thumb);
        }
      }
      form.addEventListener('change', update);
      $$('[data-swatch]', form).forEach(function (sw) {
        sw.addEventListener('click', function () {
          var group = sw.closest('[data-option-index]');
          $$('[data-swatch]', group).forEach(function (s) { s.setAttribute('aria-checked','false'); });
          sw.setAttribute('aria-checked','true');
          var hidden = group.querySelector('input[type="hidden"]'); if (hidden) hidden.value = sw.value;
          var lbl = group.querySelector('[data-option-value]'); if (lbl) lbl.textContent = sw.value;
          update();
        });
      });
      update();
    });
    }

    // Initial bind on the whole document; re-bindable for injected scopes (quick-view).
    function bindProductScope(root) { bindProductForms(root); bindVariants(root); }
    KADI.bindProductScope = bindProductScope;
    bindProductScope(document);

    /* --------------------------------------------------------- PDP GALLERY */
    function setStageImage(thumb) {
      var stage = $('[data-gallery-stage]');
      if (!stage) return;
      var img = stage.querySelector('img');
      if (!img) { img = document.createElement('img'); stage.innerHTML = ''; stage.appendChild(img); }
      img.removeAttribute('srcset');
      img.src = thumb.getAttribute('data-full');
      img.alt = thumb.getAttribute('data-alt') || '';
      $$('[data-gallery-thumbs] [data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    $$('[data-gallery-thumbs] [data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { setStageImage(thumb); });
    });

    /* ----------------------------------------------------------- QUICK VIEW */
    var qvModal = $('[data-quickview-modal]');
    function openQuickView(url) {
      if (!qvModal) { window.location = url; return; }
      var body = qvModal.querySelector('[data-quickview-body]');
      body.innerHTML = '<div class="qv-loading label">Loading…</div>';
      qvModal.hidden = false; requestAnimationFrame(function(){ qvModal.classList.add('is-open'); });
      showOverlay(); if (KADI.stopScroll) KADI.stopScroll();
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quickview')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-quickview-content]') || doc.querySelector('main');
          body.innerHTML = content ? content.innerHTML : '<p class="muted">Preview unavailable.</p>';
          if (KADI.bindProductScope) KADI.bindProductScope(body);
        })
        .catch(function () { window.location = url; });
    }
    function closeQuickView() {
      if (!qvModal) return; qvModal.classList.remove('is-open');
      if (!drawerOpen && !menuOpen) hideOverlay();
      if (KADI.startScroll) KADI.startScroll();
      setTimeout(function(){ qvModal.hidden = true; }, 300);
    }
    $$('[data-quickview]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openQuickView(btn.getAttribute('data-quickview') || btn.href); });
    });
    if (qvModal) qvModal.addEventListener('click', function (e) { if (e.target.closest('[data-quickview-close]') || e.target === qvModal) closeQuickView(); });
  });
})();
